export function HandshakeIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m11 17 2 2a1 1 0 1 0 3-3" />
      <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
      <path d="m21 3 1 11h-2" />
      <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
      <path d="M3 4h8" />
    </svg>
  );
}

export function LightbulbIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
      <path d="M9 18h6" />
      <path d="M10 22h4" />
    </svg>
  );
}

export function RocketIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
      <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
      <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
      <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
    </svg>
  );
}
export function DropDownSvg(props) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7401 3.32223C13.5671 3.14903 13.3619 3.0625 13.1249 3.0625H0.875066C0.637935 3.0625 0.432936 3.14903 0.259733 3.32223C0.0865297 3.49563 0 3.70063 0 3.93761C0 4.17455 0.0865297 4.37955 0.259733 4.5528L6.38467 10.6777C6.55806 10.8509 6.76306 10.9377 7 10.9377C7.23694 10.9377 7.44213 10.8509 7.61519 10.6777L13.7401 4.55276C13.9131 4.37955 14 4.17455 14 3.93757C14 3.70063 13.9131 3.49563 13.7401 3.32223Z"
        fill="#C70048"
      />
    </svg>
  );
}
export function CheckSvg(props) {
  return (
    <svg
      width="13"
      height="11"
      viewBox="0 0 13 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.41537 10.1567L0.190373 5.93169C-0.0634575 5.67786 -0.0634575 5.2663 0.190373 5.01245L1.10959 4.0932C1.36342 3.83935 1.775 3.83935 2.02883 4.0932L4.87499 6.93934L10.9712 0.843205C11.225 0.589375 11.6366 0.589375 11.8904 0.843205L12.8096 1.76245C13.0634 2.01628 13.0634 2.42783 12.8096 2.68169L5.33462 10.1567C5.08076 10.4105 4.6692 10.4105 4.41537 10.1567Z"
        fill="#243656"
      />
    </svg>
  );
}
export function CrossSvg(props) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="white" />
      <path
        d="M16.4658 15.0131L22.6959 8.78287C23.1014 8.37762 23.1014 7.72238 22.6959 7.31712C22.2907 6.91187 21.6354 6.91187 21.2302 7.31712L14.9999 13.5474L8.76983 7.31712C8.36438 6.91187 7.70934 6.91187 7.30408 7.31712C6.89864 7.72238 6.89864 8.37762 7.30408 8.78287L13.5342 15.0131L7.30408 21.2434C6.89864 21.6487 6.89864 22.3039 7.30408 22.7092C7.50604 22.9113 7.77159 23.0129 8.03695 23.0129C8.30232 23.0129 8.56768 22.9113 8.76983 22.7092L14.9999 16.4789L21.2302 22.7092C21.4323 22.9113 21.6977 23.0129 21.9631 23.0129C22.2284 23.0129 22.4938 22.9113 22.6959 22.7092C23.1014 22.3039 23.1014 21.6487 22.6959 21.2434L16.4658 15.0131Z"
        fill="#C70048"
      />
    </svg>
  );
}

export function UsersIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}
export function PrevIcon() {
  return (
    <svg
      width="9"
      height="14"
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.49504 13.9961C7.69349 13.9973 7.8878 13.9393 8.05318 13.8296C8.21856 13.7199 8.34752 13.5634 8.42362 13.3801C8.49972 13.1969 8.51952 12.9951 8.48048 12.8005C8.44144 12.6059 8.34534 12.4273 8.20443 12.2876L2.90892 7.00207L8.20443 1.71655C8.39258 1.5284 8.49828 1.27322 8.49828 1.00715C8.49828 0.8754 8.47233 0.744943 8.42191 0.623224C8.37149 0.501505 8.29759 0.390909 8.20443 0.297749C8.11128 0.204589 8.00068 0.130691 7.87896 0.0802738C7.75724 0.0298562 7.62678 0.00390625 7.49504 0.00390625C7.22896 0.00390625 6.97378 0.109605 6.78564 0.297749L0.790716 6.29267C0.604623 6.47987 0.50017 6.73311 0.50017 6.99707C0.50017 7.26103 0.604623 7.51427 0.790716 7.70148L6.78564 13.6964C6.87817 13.7908 6.98852 13.8659 7.1103 13.9174C7.23207 13.9688 7.36284 13.9956 7.49504 13.9961Z"
        fill="#C70048"
      />
    </svg>
  );
}
